import React from 'react'
import styled from '@emotion/styled'
import { CssBaseline } from '@mui/material'

const Root = styled("div")({
    display: "flex",
    minHeight: "100vh"

});

const AppContent = styled("div")({

    flex: "1",
    display: "flex",
    flexDirection: "column"
})

function Presentation({ children }) {
    return (
        <Root>
            <CssBaseline />
            <AppContent>{children}</AppContent>
        </Root>
    )
}

export default Presentation